var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"clearable":"","outlined":"","required":"","dense":"","offset-y":"","hide-details":"","prepend-inner-icon":"mdi-calendar-outline","item-value":"value","menu-props":{
    bottom: true,
    offsetY: true,
  },"value":_vm.initialDay,"items":_vm.days,"label":_vm.$t('routines_reminder.day'),"placeholder":_vm.$t('routines_reminder.day')},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }